import { Footer as DSFRFooter } from '@codegouvfr/react-dsfr/Footer';

function Footer() {
  return (
    <DSFRFooter
      accessibility="non compliant"
      contentDescription="Outil numérique pour la surveillance et le contrôle des denrées alimentaires"
    />
  );
}

export default Footer;
